
import Icon from "../../../components/icon/index.vue";
import Navbar from "../../../components/navbar.vue";
import { useConfirmDialog } from "@vueuse/core";
import { ref } from "vue";
import GeoSearchPopup from "../../../popups/geo-search.vue";
import { useRouter } from "vue-router";
import { useUserProfileStore } from "../../../stores/user-profile";

export default {
  name: "EditProfile",
  components: {
    Icon,
    Navbar,
    GeoSearchPopup,
  },
  async setup() {
    const router = useRouter();
    const { userProfile } = useUserProfileStore();

    const location = ref<{
      title: string;
      subtitle: string;
      country: string;
      location: {
        longitude: number;
        latitude: number;
      };
      bbox: [number, number, number, number];
    }>();

    const geoSearchDialog = useConfirmDialog();
    geoSearchDialog.onConfirm((data) => {
      location.value = data;
    });

    async function submit() {
      await userProfile.$update();
      router.back();
    }

    return {
      userProfile,
      location,
      geoSearchDialog,
      submit,
    };
  },
};
